import * as React from "react"
const SvgComponent = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#344054"
      strokeWidth={1.5}
      d="M3.095 10c-.063.457-.095.925-.095 1.4 0 5.302 4.03 9.6 9 9.6s9-4.298 9-9.6c0-.476-.032-.943-.095-1.4M12 3v10m0-10L9 6m3-3 3 3"
    />
  </svg>
)
export default SvgComponent
